// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * This contains default colors, fonts, etc
 **/
:root {
--white: #F0F0F0;

--grey: #39393D;
--orange: #E7431E;
--blue: #225AA2;
--blue: rgb( 34, 90, 162, 0.2 );
--light-grey: #ADADAD;
--light-grey-10: rgb( 173, 173, 173, 0.1 );
--light-grey-30: rgb( 173, 173, 173, 0.1 );
--light-grey-50: rgb( 173, 173, 173, 0.1 );
--lighter-grey: #EEEEEE;
/*
--green: #25B7B7;
--dark-green: #15A7A7;
--darker-green: #059797;
--purple: #5737BE;*/
--green: #2226C3;
--green-10: rgb( 34, 38, 195, 0.1 );
--green-25: rgb( 34, 38, 195, 0.25 );
--green-light: #5051b6;

--dark-green: rgb(28, 30, 156);
--darker-green: rgb(15, 16, 90);
--purple: #3A37D7;
--purple-light: #d8d7f7;
--purple-5: rgba(58, 55, 215, 0.05);
--purple-15: rgba(58, 55, 215, 0.15);
--purple-20: rgba(58, 55, 215, 0.2);
--purple-25: rgba(58, 55, 215, 0.25);
--purple-30: rgba(58, 55, 215, 0.3);
--purple-30: rgba(58, 55, 215, 0.5);

--red: rgba(196,0,0,1.0);
--background: #F4F6FA;

--yellow:#EEC755;
--pink: #C51A67;
--pink-light: #c45b8a;

--box-shadow-1: rgba(0,0,0,0.15);

--primary: var( --pink );

--primary-action: var( --purple );

--hover-on-dark-background: rgba(255,255,255,0.2);

--secondary : var( --blue );
--sidebar-bg: var( --background );
--sidebar-color: #565656;
--sidebar-label-opacity : 60%;
--sidebar-selected-color: var( --background );
--sidebar-nav-hover: var( --hover-on-dark-background );
--sidebar-width : 170px;

--font-size-base:          14px;
--font-size-large:         18px;
--font-size-small:         12px;

--label-size: 75px;
--border-color: #d6d6d6; 

}
`, "",{"version":3,"sources":["webpack://./src/style/theme.css"],"names":[],"mappings":"AAAA;;GAEG;AACH;AACA,gBAAgB;;AAEhB,eAAe;AACf,iBAAiB;AACjB,eAAe;AACf,+BAA+B;AAC/B,qBAAqB;AACrB,0CAA0C;AAC1C,0CAA0C;AAC1C,0CAA0C;AAC1C,uBAAuB;AACvB;;;;mBAImB;AACnB,gBAAgB;AAChB,mCAAmC;AACnC,oCAAoC;AACpC,sBAAsB;;AAEtB,8BAA8B;AAC9B,+BAA+B;AAC/B,iBAAiB;AACjB,uBAAuB;AACvB,mCAAmC;AACnC,oCAAoC;AACpC,mCAAmC;AACnC,oCAAoC;AACpC,mCAAmC;AACnC,mCAAmC;;AAEnC,wBAAwB;AACxB,qBAAqB;;AAErB,gBAAgB;AAChB,eAAe;AACf,qBAAqB;;AAErB,gCAAgC;;AAEhC,wBAAwB;;AAExB,iCAAiC;;AAEjC,iDAAiD;;AAEjD,2BAA2B;AAC3B,iCAAiC;AACjC,wBAAwB;AACxB,6BAA6B;AAC7B,6CAA6C;AAC7C,sDAAsD;AACtD,uBAAuB;;AAEvB,+BAA+B;AAC/B,+BAA+B;AAC/B,+BAA+B;;AAE/B,kBAAkB;AAClB,uBAAuB;;AAEvB","sourcesContent":["/**\n * This contains default colors, fonts, etc\n **/\n:root {\n--white: #F0F0F0;\n\n--grey: #39393D;\n--orange: #E7431E;\n--blue: #225AA2;\n--blue: rgb( 34, 90, 162, 0.2 );\n--light-grey: #ADADAD;\n--light-grey-10: rgb( 173, 173, 173, 0.1 );\n--light-grey-30: rgb( 173, 173, 173, 0.1 );\n--light-grey-50: rgb( 173, 173, 173, 0.1 );\n--lighter-grey: #EEEEEE;\n/*\n--green: #25B7B7;\n--dark-green: #15A7A7;\n--darker-green: #059797;\n--purple: #5737BE;*/\n--green: #2226C3;\n--green-10: rgb( 34, 38, 195, 0.1 );\n--green-25: rgb( 34, 38, 195, 0.25 );\n--green-light: #5051b6;\n\n--dark-green: rgb(28, 30, 156);\n--darker-green: rgb(15, 16, 90);\n--purple: #3A37D7;\n--purple-light: #d8d7f7;\n--purple-5: rgba(58, 55, 215, 0.05);\n--purple-15: rgba(58, 55, 215, 0.15);\n--purple-20: rgba(58, 55, 215, 0.2);\n--purple-25: rgba(58, 55, 215, 0.25);\n--purple-30: rgba(58, 55, 215, 0.3);\n--purple-30: rgba(58, 55, 215, 0.5);\n\n--red: rgba(196,0,0,1.0);\n--background: #F4F6FA;\n\n--yellow:#EEC755;\n--pink: #C51A67;\n--pink-light: #c45b8a;\n\n--box-shadow-1: rgba(0,0,0,0.15);\n\n--primary: var( --pink );\n\n--primary-action: var( --purple );\n\n--hover-on-dark-background: rgba(255,255,255,0.2);\n\n--secondary : var( --blue );\n--sidebar-bg: var( --background );\n--sidebar-color: #565656;\n--sidebar-label-opacity : 60%;\n--sidebar-selected-color: var( --background );\n--sidebar-nav-hover: var( --hover-on-dark-background );\n--sidebar-width : 170px;\n\n--font-size-base:          14px;\n--font-size-large:         18px;\n--font-size-small:         12px;\n\n--label-size: 75px;\n--border-color: #d6d6d6; \n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
